module.exports = __webpack_public_path__ + "static/img/screen-shot-2019-01-08-at-12-38-38-copy.f95b294.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Cronus/screen-shot-2019-01-08-at-12-38-38-copy.png
// module id = S2kO
// module chunks = 0